import styled, { css } from 'styled-components';
import { Colors } from '../../../../../values/colors';
import ArrowDownIcon from '../../../../../assets/images/icon_arrow_down.svg'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 16px 0;
`;

export const Position = styled.span`
  font: 'Nunito Sans', sans-serif 14px 600;
  color: ${Colors.blueGray2};
  margin-right: 20px;
`;

export const Select = styled.select`
  width: 100%;
  margin-left: 8px;
  appearance: none;
  background-image: url(${ArrowDownIcon});
  background-repeat: no-repeat;
  background-position: right 17px center;
  background-size: 16px 14px;
  &:disabled {
    background-image: none;
    background-color: ${Colors.white2};
    opacity: 1;
  }
  
  &:focus {
    outline: none;
  }
`;

export const MenuContainer = styled.div`
  display: flex;
  padding: 8px 0;
  padding-left: 15px;
  width: 315px;
  flex-direction: row;
  align-items: center;
  border: .7px solid ${Colors.lightGray2};
  background-color: ${Colors.white};
  border-radius: 5px;
  ${({ disabled }) => disabled && css`
    background-image: none;
    background-color: ${Colors.white2};
    border: 0.7px solid ${Colors.lightGray2};
    opacity: 1;
  `}
`;